/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Formulas_DescriptionInputs */

const en_gc_resources_guide_formulas_description = /** @type {(inputs: Gc_Resources_Guide_Formulas_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use SUM for a total and IF to turn a number into a useful decision.`)
};

const zh_gc_resources_guide_formulas_description = /** @type {(inputs: Gc_Resources_Guide_Formulas_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 SUM 计算总数，用 IF 根据数值作出判断。`)
};

/**
* | output |
* | --- |
* | "Use SUM for a total and IF to turn a number into a useful decision." |
*
* @param {Gc_Resources_Guide_Formulas_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_formulas_description = /** @type {((inputs?: Gc_Resources_Guide_Formulas_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Formulas_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_formulas_description(inputs)
	return zh_gc_resources_guide_formulas_description(inputs)
});
export { gc_resources_guide_formulas_description as "gc.resources.guide.formulas.description" }